import { z } from 'zod';

import { zodContractConditionKindSchema } from '../validations';

/**
 * Validation schemas for the contract condition name suggestions API call.
 */

// Query parameter validations
export const zodContractConditionNameSuggestionsQueryParamsSchema = z.object({
  excludeContractId: z.uuid().optional(),
  kind: zodContractConditionKindSchema.optional(),
  limit: z.number().int().min(1).max(5).optional().prefault(5),
  query: z.string().trim().max(255).optional(),
  sellerCompanyId: z.uuid().optional(),
});

// Response schema
const zodContractConditionNameSuggestionItemSchema = z.object({
  name: z.string(),
  usageCount: z.number().int().nonnegative(),
});

export const zodContractConditionNameSuggestionsResponseSchema = z.object({
  data: z.array(zodContractConditionNameSuggestionItemSchema),
});
